import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalDialogComponent } from 'src/app/controls/components/advanced/modal-dialog/modal-dialog.component';
import { ButtonComponent } from 'src/app/controls/components/basic/button/button.component';
import { CheckboxComponent } from 'src/app/controls/components/basic/checkbox/checkbox.component';
import { LayoutColumnComponent } from 'src/app/controls/components/basic/layout-column/layout-column.component';
import { LayoutRowComponent } from 'src/app/controls/components/basic/layout-row/layout-row.component';
import { TextboxComponent } from 'src/app/controls/components/basic/textbox/textbox.component';
import { ButtonPrimaryDirective } from 'src/app/controls/directives/button-primary.directive';
import { ButtonSecondaryDirective } from 'src/app/controls/directives/button-secondary.directive';

@Component({
  selector: 'app-partner-onboarding-reopen-dialog',
  standalone: true,
  imports: [ModalDialogComponent, FormsModule, ButtonComponent, ButtonPrimaryDirective, CheckboxComponent, TextboxComponent, ButtonSecondaryDirective, ModalDialogComponent, LayoutColumnComponent, LayoutRowComponent],
  templateUrl: './partner-onboarding-reopen-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './partner-onboarding-reopen-dialog.component.scss'
})
export class PartnerOnboardingReopenDialogComponent {
  private dialog = inject(NgbActiveModal);
  notifyPartner = false;
  notificationMessage = '';

  reopen() {
    if (this.notifyPartner) {
      this.dialog.close({ type: ReopenType.ReopenAndNotify, notificationMessage: this.notificationMessage });
    }

    this.dialog.close({ type: ReopenType.Reopen });
  }

  cancel() {
    this.dialog.close({ type: ReopenType.Cancel });
  }
}

export interface PartnerOnboardingReopenDialogResult {
  type: ReopenType;
  notificationMessage?: string;
}

export enum ReopenType {
  Reopen,
  ReopenAndNotify,
  Cancel 
}
